import { TRACK_CART_VIEWED } from '../types';
export var trackCartViewed = function trackCartViewed(options) {
  return {
    type: TRACK_CART_VIEWED,
    payload: options
  };
};